import { Button, Input } from '@cian/ui-kit';
import * as React from 'react';

import { ModalConfirm } from '../../ModalConfirm';

interface IProps {
  isVisible: boolean;
  onConfirm(name: string): void;
  onCancel(): void;
}

export function ModalCreateFolder({ isVisible, onConfirm, onCancel }: IProps) {
  const [name, setName] = React.useState('');

  return (
    <ModalConfirm
      text="Новая подборка"
      onClose={onCancel}
      isVisible={isVisible}
      footer={
        <>
          <Button theme="fill_white_primary" size="XS" onClick={onCancel}>
            Отменить
          </Button>
          <Button disabled={!name} size="XS" onClick={() => onConfirm(name)}>
            Сохранить
          </Button>
        </>
      }
    >
      <Input placeholder="Название подборки" maxLength={150} onChange={e => setName(e.target.value)} />
    </ModalConfirm>
  );
}
